/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type __SubscriptionContainer = {
  onCreateUser: OnCreateUserSubscription;
  onUpdateUser: OnUpdateUserSubscription;
  onDeleteUser: OnDeleteUserSubscription;
  onCreateFaq: OnCreateFaqSubscription;
  onUpdateFaq: OnUpdateFaqSubscription;
  onDeleteFaq: OnDeleteFaqSubscription;
  onCreateBonus: OnCreateBonusSubscription;
  onUpdateBonus: OnUpdateBonusSubscription;
  onDeleteBonus: OnDeleteBonusSubscription;
  onCreateContract: OnCreateContractSubscription;
  onUpdateContract: OnUpdateContractSubscription;
  onDeleteContract: OnDeleteContractSubscription;
  onCreateTeam: OnCreateTeamSubscription;
  onUpdateTeam: OnUpdateTeamSubscription;
  onDeleteTeam: OnDeleteTeamSubscription;
  onCreateSupportRequest: OnCreateSupportRequestSubscription;
  onUpdateSupportRequest: OnUpdateSupportRequestSubscription;
  onDeleteSupportRequest: OnDeleteSupportRequestSubscription;
  onCreateTicket: OnCreateTicketSubscription;
  onUpdateTicket: OnUpdateTicketSubscription;
  onDeleteTicket: OnDeleteTicketSubscription;
  onCreateNotification: OnCreateNotificationSubscription;
  onUpdateNotification: OnUpdateNotificationSubscription;
  onDeleteNotification: OnDeleteNotificationSubscription;
  onCreateBonusGenerationProcess: OnCreateBonusGenerationProcessSubscription;
  onUpdateBonusGenerationProcess: OnUpdateBonusGenerationProcessSubscription;
  onDeleteBonusGenerationProcess: OnDeleteBonusGenerationProcessSubscription;
};

export type CreateUserInput = {
  id?: string | null;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: S3ObjectInput | null;
  FcodiceFiscale?: S3ObjectInput | null;
  FpatenteGuida?: S3ObjectInput | null;
  FverificaCasellare?: S3ObjectInput | null;
  FprovaResidednza?: S3ObjectInput | null;
  FcontrattoInvestimento?: S3ObjectInput | null;
  FcartaIdentitaAutenticata?: S3ObjectInput | null;
  FprovaResidenzaAutenticata?: S3ObjectInput | null;
  FdeclarationIndividual?: S3ObjectInput | null;
  FprofessionalReference?: S3ObjectInput | null;
  FcurricolumVitae?: S3ObjectInput | null;
  FsowForm?: S3ObjectInput | null;
  FprorogaContrattuale?: S3ObjectInput | null;
  FpassaggioContrattuale?: S3ObjectInput | null;
  FdocumentoSuccessione?: S3ObjectInput | null;
  FquitanzaLiquidazione?: S3ObjectInput | null;
  Fmanleva?: S3ObjectInput | null;
  FapplicationRelease?: S3ObjectInput | null;
  FwidthrowForm?: S3ObjectInput | null;
  FsvincoloParziale?: S3ObjectInput | null;
  FsvincoloTotale?: S3ObjectInput | null;
  Fextra1?: S3ObjectInput | null;
  Fextra2?: S3ObjectInput | null;
  profileImg?: S3ObjectInput | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  _version?: number | null;
};

export enum PermissionType {
  CLIENT = "CLIENT",
  COMMERCIAL = "COMMERCIAL",
  ADMINISTRATOR = "ADMINISTRATOR"
}

export type S3ObjectInput = {
  bucket?: string | null;
  region?: string | null;
  key?: string | null;
  validated?: boolean | null;
  updateDate?: string | null;
};

export type ModelUserConditionInput = {
  name?: ModelStringInput | null;
  lastname?: ModelStringInput | null;
  teamID?: ModelIDInput | null;
  email?: ModelStringInput | null;
  phoneNumber?: ModelStringInput | null;
  assignedTo?: ModelStringInput | null;
  addedBy?: ModelStringInput | null;
  role?: ModelStringInput | null;
  permessions?: ModelPermissionTypeInput | null;
  notes?: ModelStringInput | null;
  numeroCI?: ModelStringInput | null;
  cf?: ModelStringInput | null;
  managerFeePercent?: ModelFloatInput | null;
  TRC20?: ModelStringInput | null;
  TRC20Active?: ModelBooleanInput | null;
  device_id?: ModelStringInput | null;
  oneSignalEmailId?: ModelStringInput | null;
  directExcutiveBonus?: ModelBooleanInput | null;
  directSeniorBonus?: ModelBooleanInput | null;
  directLeaderBonus?: ModelBooleanInput | null;
  downlineExcutiveBonus?: ModelBooleanInput | null;
  downlineSeniorBonus?: ModelBooleanInput | null;
  downlineLeaderBonus?: ModelBooleanInput | null;
  notification?: ModelBooleanInput | null;
  totalActiveContracts?: ModelFloatInput | null;
  and?: Array<ModelUserConditionInput | null> | null;
  or?: Array<ModelUserConditionInput | null> | null;
  not?: ModelUserConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelPermissionTypeInput = {
  eq?: PermissionType | null;
  ne?: PermissionType | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type User = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: ModelBonusConnection | null;
  ContractsAdded?: ModelContractConnection | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: S3Object | null;
  FcodiceFiscale?: S3Object | null;
  FpatenteGuida?: S3Object | null;
  FverificaCasellare?: S3Object | null;
  FprovaResidednza?: S3Object | null;
  FcontrattoInvestimento?: S3Object | null;
  FcartaIdentitaAutenticata?: S3Object | null;
  FprovaResidenzaAutenticata?: S3Object | null;
  FdeclarationIndividual?: S3Object | null;
  FprofessionalReference?: S3Object | null;
  FcurricolumVitae?: S3Object | null;
  FsowForm?: S3Object | null;
  FprorogaContrattuale?: S3Object | null;
  FpassaggioContrattuale?: S3Object | null;
  FdocumentoSuccessione?: S3Object | null;
  FquitanzaLiquidazione?: S3Object | null;
  Fmanleva?: S3Object | null;
  FapplicationRelease?: S3Object | null;
  FwidthrowForm?: S3Object | null;
  FsvincoloParziale?: S3Object | null;
  FsvincoloTotale?: S3Object | null;
  Fextra1?: S3Object | null;
  Fextra2?: S3Object | null;
  profileImg?: S3Object | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type ModelBonusConnection = {
  __typename: "ModelBonusConnection";
  items: Array<Bonus | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type Bonus = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: User | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: BonusGenerationProcess | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export enum BonusStatus {
  Pagato = "Pagato",
  NonPagato = "NonPagato"
}

export enum BonusType {
  Marketing_Fee_1 = "Marketing_Fee_1",
  Manager_Fee_2 = "Manager_Fee_2",
  Bonus_Team_3 = "Bonus_Team_3",
  Revenue_Bonus_4 = "Revenue_Bonus_4",
  Sponsor_Bonus_5 = "Sponsor_Bonus_5",
  Manager_Bonus_6 = "Manager_Bonus_6",
  Ambassador_Bonus_7 = "Ambassador_Bonus_7",
  Company_Bonus_8 = "Company_Bonus_8",
  Director_Bonus_9 = "Director_Bonus_9"
}

export type BonusGenerationProcess = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type ModelContractConnection = {
  __typename: "ModelContractConnection";
  items: Array<Contract | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type Contract = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: S3Object | null;
  commercial?: User | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type S3Object = {
  __typename: "S3Object";
  bucket?: string | null;
  region?: string | null;
  key?: string | null;
  validated?: boolean | null;
  updateDate?: string | null;
};

export type UpdateUserInput = {
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: S3ObjectInput | null;
  FcodiceFiscale?: S3ObjectInput | null;
  FpatenteGuida?: S3ObjectInput | null;
  FverificaCasellare?: S3ObjectInput | null;
  FprovaResidednza?: S3ObjectInput | null;
  FcontrattoInvestimento?: S3ObjectInput | null;
  FcartaIdentitaAutenticata?: S3ObjectInput | null;
  FprovaResidenzaAutenticata?: S3ObjectInput | null;
  FdeclarationIndividual?: S3ObjectInput | null;
  FprofessionalReference?: S3ObjectInput | null;
  FcurricolumVitae?: S3ObjectInput | null;
  FsowForm?: S3ObjectInput | null;
  FprorogaContrattuale?: S3ObjectInput | null;
  FpassaggioContrattuale?: S3ObjectInput | null;
  FdocumentoSuccessione?: S3ObjectInput | null;
  FquitanzaLiquidazione?: S3ObjectInput | null;
  Fmanleva?: S3ObjectInput | null;
  FapplicationRelease?: S3ObjectInput | null;
  FwidthrowForm?: S3ObjectInput | null;
  FsvincoloParziale?: S3ObjectInput | null;
  FsvincoloTotale?: S3ObjectInput | null;
  Fextra1?: S3ObjectInput | null;
  Fextra2?: S3ObjectInput | null;
  profileImg?: S3ObjectInput | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  _version?: number | null;
};

export type DeleteUserInput = {
  id: string;
  _version?: number | null;
};

export type CreateFaqInput = {
  id?: string | null;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  _version?: number | null;
};

export type ModelFaqConditionInput = {
  question?: ModelStringInput | null;
  answer?: ModelStringInput | null;
  category?: ModelStringInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelFaqConditionInput | null> | null;
  or?: Array<ModelFaqConditionInput | null> | null;
  not?: ModelFaqConditionInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type Faq = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type UpdateFaqInput = {
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  _version?: number | null;
};

export type DeleteFaqInput = {
  id: string;
  _version?: number | null;
};

export type CreateBonusInput = {
  id?: string | null;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  _version?: number | null;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type ModelBonusConditionInput = {
  type?: ModelStringInput | null;
  basePerc?: ModelFloatInput | null;
  capitalPerc?: ModelFloatInput | null;
  annualPerc?: ModelFloatInput | null;
  levelPerc?: ModelFloatInput | null;
  contractId?: ModelIDInput | null;
  date?: ModelStringInput | null;
  total?: ModelFloatInput | null;
  status?: ModelBonusStatusInput | null;
  payDate?: ModelStringInput | null;
  typeEnum?: ModelBonusTypeInput | null;
  info?: ModelStringInput | null;
  and?: Array<ModelBonusConditionInput | null> | null;
  or?: Array<ModelBonusConditionInput | null> | null;
  not?: ModelBonusConditionInput | null;
  userBonusId?: ModelIDInput | null;
  bonusProcessId?: ModelIDInput | null;
};

export type ModelBonusStatusInput = {
  eq?: BonusStatus | null;
  ne?: BonusStatus | null;
};

export type ModelBonusTypeInput = {
  eq?: BonusType | null;
  ne?: BonusType | null;
};

export type UpdateBonusInput = {
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  _version?: number | null;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type DeleteBonusInput = {
  id: string;
  _version?: number | null;
};

export type CreateContractInput = {
  id?: string | null;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: S3ObjectInput | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  _version?: number | null;
  userContractsAddedId?: string | null;
};

export type ModelContractConditionInput = {
  clientId?: ModelIDInput | null;
  notes?: ModelStringInput | null;
  date?: ModelStringInput | null;
  durationInDays?: ModelIntInput | null;
  amount?: ModelFloatInput | null;
  fileIdentifier?: ModelStringInput | null;
  capital?: ModelFloatInput | null;
  startDate?: ModelStringInput | null;
  endDate?: ModelStringInput | null;
  percent?: ModelFloatInput | null;
  totalWithBounoce?: ModelFloatInput | null;
  product?: ModelStringInput | null;
  status?: ModelStringInput | null;
  bonusGenerated?: ModelBooleanInput | null;
  bonusActiveFirstYear?: ModelFloatInput | null;
  bonusRecurrence?: ModelFloatInput | null;
  extended?: ModelBooleanInput | null;
  extendedFromDate?: ModelStringInput | null;
  extendedBy?: ModelStringInput | null;
  updatedBy?: ModelStringInput | null;
  extendedTimeStamp?: ModelStringInput | null;
  contractYears?: ModelIntInput | null;
  notification?: ModelBooleanInput | null;
  and?: Array<ModelContractConditionInput | null> | null;
  or?: Array<ModelContractConditionInput | null> | null;
  not?: ModelContractConditionInput | null;
  userContractsAddedId?: ModelIDInput | null;
};

export type UpdateContractInput = {
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: S3ObjectInput | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  _version?: number | null;
  userContractsAddedId?: string | null;
};

export type DeleteContractInput = {
  id: string;
  _version?: number | null;
};

export type CreateTeamInput = {
  id?: string | null;
  name: string;
  description?: string | null;
  _version?: number | null;
  teamManagerId?: string | null;
};

export type ModelTeamConditionInput = {
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelTeamConditionInput | null> | null;
  or?: Array<ModelTeamConditionInput | null> | null;
  not?: ModelTeamConditionInput | null;
  teamManagerId?: ModelIDInput | null;
};

export type Team = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: ModelUserConnection | null;
  manager?: User | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection";
  items: Array<User | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type UpdateTeamInput = {
  id: string;
  name?: string | null;
  description?: string | null;
  _version?: number | null;
  teamManagerId?: string | null;
};

export type DeleteTeamInput = {
  id: string;
  _version?: number | null;
};

export type CreateSupportRequestInput = {
  id?: string | null;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  message?: string | null;
  createdAt?: string | null;
  ticketId?: string | null;
  _version?: number | null;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type ModelSupportRequestConditionInput = {
  agentId?: ModelStringInput | null;
  clientId?: ModelStringInput | null;
  fromId?: ModelIDInput | null;
  message?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  ticketId?: ModelIDInput | null;
  and?: Array<ModelSupportRequestConditionInput | null> | null;
  or?: Array<ModelSupportRequestConditionInput | null> | null;
  not?: ModelSupportRequestConditionInput | null;
  ticketMessagesId?: ModelIDInput | null;
  supportRequestFromUserId?: ModelIDInput | null;
};

export type SupportRequest = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: User | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: Ticket | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type Ticket = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: User | null;
  messages?: ModelSupportRequestConnection | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type ModelSupportRequestConnection = {
  __typename: "ModelSupportRequestConnection";
  items: Array<SupportRequest | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export enum TicketStatus {
  OPEND = "OPEND",
  WAITINGRESPONSE = "WAITINGRESPONSE",
  ARCHIVED = "ARCHIVED"
}

export type UpdateSupportRequestInput = {
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  message?: string | null;
  createdAt?: string | null;
  ticketId?: string | null;
  _version?: number | null;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type DeleteSupportRequestInput = {
  id: string;
  _version?: number | null;
};

export type CreateTicketInput = {
  id?: string | null;
  title: string;
  ticketStatus?: TicketStatus | null;
  _version?: number | null;
  ticketClientId?: string | null;
};

export type ModelTicketConditionInput = {
  title?: ModelIDInput | null;
  ticketStatus?: ModelTicketStatusInput | null;
  and?: Array<ModelTicketConditionInput | null> | null;
  or?: Array<ModelTicketConditionInput | null> | null;
  not?: ModelTicketConditionInput | null;
  ticketClientId?: ModelIDInput | null;
};

export type ModelTicketStatusInput = {
  eq?: TicketStatus | null;
  ne?: TicketStatus | null;
};

export type UpdateTicketInput = {
  id: string;
  title?: string | null;
  ticketStatus?: TicketStatus | null;
  _version?: number | null;
  ticketClientId?: string | null;
};

export type DeleteTicketInput = {
  id: string;
  _version?: number | null;
};

export type CreateNotificationInput = {
  id?: string | null;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  _version?: number | null;
};

export type ModelNotificationConditionInput = {
  userId?: ModelStringInput | null;
  msg?: ModelStringInput | null;
  isSeen?: ModelBooleanInput | null;
  isOperator?: ModelBooleanInput | null;
  isAdmin?: ModelBooleanInput | null;
  url?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelNotificationConditionInput | null> | null;
  or?: Array<ModelNotificationConditionInput | null> | null;
  not?: ModelNotificationConditionInput | null;
};

export type Notification = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type UpdateNotificationInput = {
  id: string;
  userId?: string | null;
  msg?: string | null;
  isSeen?: boolean | null;
  isOperator?: boolean | null;
  isAdmin?: boolean | null;
  url?: string | null;
  createdAt?: string | null;
  _version?: number | null;
};

export type DeleteNotificationInput = {
  id: string;
  _version?: number | null;
};

export type CreateBonusGenerationProcessInput = {
  id?: string | null;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  _version?: number | null;
};

export type ModelBonusGenerationProcessConditionInput = {
  date?: ModelStringInput | null;
  type?: ModelStringInput | null;
  startDate?: ModelStringInput | null;
  endDate?: ModelStringInput | null;
  stato?: ModelStringInput | null;
  pagamenti?: ModelStringInput | null;
  info?: ModelStringInput | null;
  note?: ModelStringInput | null;
  and?: Array<ModelBonusGenerationProcessConditionInput | null> | null;
  or?: Array<ModelBonusGenerationProcessConditionInput | null> | null;
  not?: ModelBonusGenerationProcessConditionInput | null;
};

export type UpdateBonusGenerationProcessInput = {
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  _version?: number | null;
};

export type DeleteBonusGenerationProcessInput = {
  id: string;
  _version?: number | null;
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  lastname?: ModelStringInput | null;
  teamID?: ModelIDInput | null;
  email?: ModelStringInput | null;
  phoneNumber?: ModelStringInput | null;
  assignedTo?: ModelStringInput | null;
  addedBy?: ModelStringInput | null;
  role?: ModelStringInput | null;
  permessions?: ModelPermissionTypeInput | null;
  notes?: ModelStringInput | null;
  numeroCI?: ModelStringInput | null;
  cf?: ModelStringInput | null;
  managerFeePercent?: ModelFloatInput | null;
  TRC20?: ModelStringInput | null;
  TRC20Active?: ModelBooleanInput | null;
  device_id?: ModelStringInput | null;
  oneSignalEmailId?: ModelStringInput | null;
  directExcutiveBonus?: ModelBooleanInput | null;
  directSeniorBonus?: ModelBooleanInput | null;
  directLeaderBonus?: ModelBooleanInput | null;
  downlineExcutiveBonus?: ModelBooleanInput | null;
  downlineSeniorBonus?: ModelBooleanInput | null;
  downlineLeaderBonus?: ModelBooleanInput | null;
  notification?: ModelBooleanInput | null;
  totalActiveContracts?: ModelFloatInput | null;
  and?: Array<ModelUserFilterInput | null> | null;
  or?: Array<ModelUserFilterInput | null> | null;
  not?: ModelUserFilterInput | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type ModelFaqFilterInput = {
  id?: ModelIDInput | null;
  question?: ModelStringInput | null;
  answer?: ModelStringInput | null;
  category?: ModelStringInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelFaqFilterInput | null> | null;
  or?: Array<ModelFaqFilterInput | null> | null;
  not?: ModelFaqFilterInput | null;
};

export type ModelFaqConnection = {
  __typename: "ModelFaqConnection";
  items: Array<Faq | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type ModelBonusFilterInput = {
  id?: ModelIDInput | null;
  type?: ModelStringInput | null;
  basePerc?: ModelFloatInput | null;
  capitalPerc?: ModelFloatInput | null;
  annualPerc?: ModelFloatInput | null;
  levelPerc?: ModelFloatInput | null;
  contractId?: ModelIDInput | null;
  date?: ModelStringInput | null;
  total?: ModelFloatInput | null;
  status?: ModelBonusStatusInput | null;
  payDate?: ModelStringInput | null;
  typeEnum?: ModelBonusTypeInput | null;
  info?: ModelStringInput | null;
  and?: Array<ModelBonusFilterInput | null> | null;
  or?: Array<ModelBonusFilterInput | null> | null;
  not?: ModelBonusFilterInput | null;
  userBonusId?: ModelIDInput | null;
  bonusProcessId?: ModelIDInput | null;
};

export type ModelContractFilterInput = {
  id?: ModelIDInput | null;
  clientId?: ModelIDInput | null;
  notes?: ModelStringInput | null;
  date?: ModelStringInput | null;
  durationInDays?: ModelIntInput | null;
  amount?: ModelFloatInput | null;
  fileIdentifier?: ModelStringInput | null;
  capital?: ModelFloatInput | null;
  startDate?: ModelStringInput | null;
  endDate?: ModelStringInput | null;
  percent?: ModelFloatInput | null;
  totalWithBounoce?: ModelFloatInput | null;
  product?: ModelStringInput | null;
  status?: ModelStringInput | null;
  bonusGenerated?: ModelBooleanInput | null;
  bonusActiveFirstYear?: ModelFloatInput | null;
  bonusRecurrence?: ModelFloatInput | null;
  extended?: ModelBooleanInput | null;
  extendedFromDate?: ModelStringInput | null;
  extendedBy?: ModelStringInput | null;
  updatedBy?: ModelStringInput | null;
  extendedTimeStamp?: ModelStringInput | null;
  contractYears?: ModelIntInput | null;
  notification?: ModelBooleanInput | null;
  and?: Array<ModelContractFilterInput | null> | null;
  or?: Array<ModelContractFilterInput | null> | null;
  not?: ModelContractFilterInput | null;
  userContractsAddedId?: ModelIDInput | null;
};

export type ModelTeamFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelTeamFilterInput | null> | null;
  or?: Array<ModelTeamFilterInput | null> | null;
  not?: ModelTeamFilterInput | null;
  teamManagerId?: ModelIDInput | null;
};

export type ModelTeamConnection = {
  __typename: "ModelTeamConnection";
  items: Array<Team | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type ModelSupportRequestFilterInput = {
  id?: ModelIDInput | null;
  agentId?: ModelStringInput | null;
  clientId?: ModelStringInput | null;
  fromId?: ModelIDInput | null;
  message?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  ticketId?: ModelIDInput | null;
  and?: Array<ModelSupportRequestFilterInput | null> | null;
  or?: Array<ModelSupportRequestFilterInput | null> | null;
  not?: ModelSupportRequestFilterInput | null;
  ticketMessagesId?: ModelIDInput | null;
  supportRequestFromUserId?: ModelIDInput | null;
};

export type ModelTicketFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelIDInput | null;
  ticketStatus?: ModelTicketStatusInput | null;
  and?: Array<ModelTicketFilterInput | null> | null;
  or?: Array<ModelTicketFilterInput | null> | null;
  not?: ModelTicketFilterInput | null;
  ticketClientId?: ModelIDInput | null;
};

export type ModelTicketConnection = {
  __typename: "ModelTicketConnection";
  items: Array<Ticket | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null;
  userId?: ModelStringInput | null;
  msg?: ModelStringInput | null;
  isSeen?: ModelBooleanInput | null;
  isOperator?: ModelBooleanInput | null;
  isAdmin?: ModelBooleanInput | null;
  url?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelNotificationFilterInput | null> | null;
  or?: Array<ModelNotificationFilterInput | null> | null;
  not?: ModelNotificationFilterInput | null;
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection";
  items: Array<Notification | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type ModelBonusGenerationProcessFilterInput = {
  id?: ModelIDInput | null;
  date?: ModelStringInput | null;
  type?: ModelStringInput | null;
  startDate?: ModelStringInput | null;
  endDate?: ModelStringInput | null;
  stato?: ModelStringInput | null;
  pagamenti?: ModelStringInput | null;
  info?: ModelStringInput | null;
  note?: ModelStringInput | null;
  and?: Array<ModelBonusGenerationProcessFilterInput | null> | null;
  or?: Array<ModelBonusGenerationProcessFilterInput | null> | null;
  not?: ModelBonusGenerationProcessFilterInput | null;
};

export type ModelBonusGenerationProcessConnection = {
  __typename: "ModelBonusGenerationProcessConnection";
  items: Array<BonusGenerationProcess | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type CreateUserMutation = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type UpdateUserMutation = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type DeleteUserMutation = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type CreateFaqMutation = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type UpdateFaqMutation = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type DeleteFaqMutation = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type CreateBonusMutation = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type UpdateBonusMutation = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type DeleteBonusMutation = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type CreateContractMutation = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type UpdateContractMutation = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type DeleteContractMutation = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type CreateTeamMutation = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type UpdateTeamMutation = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type DeleteTeamMutation = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type CreateSupportRequestMutation = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type UpdateSupportRequestMutation = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type DeleteSupportRequestMutation = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type CreateTicketMutation = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type UpdateTicketMutation = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type DeleteTicketMutation = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type CreateNotificationMutation = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type UpdateNotificationMutation = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type DeleteNotificationMutation = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type CreateBonusGenerationProcessMutation = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type UpdateBonusGenerationProcessMutation = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type DeleteBonusGenerationProcessMutation = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type GetUserQuery = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type ListUsersQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncUsersQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type UserByEmailQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetFaqQuery = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type ListFaqsQuery = {
  __typename: "ModelFaqConnection";
  items: Array<{
    __typename: "Faq";
    id: string;
    question?: string | null;
    answer?: string | null;
    category?: string | null;
    order?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncFaqsQuery = {
  __typename: "ModelFaqConnection";
  items: Array<{
    __typename: "Faq";
    id: string;
    question?: string | null;
    answer?: string | null;
    category?: string | null;
    order?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetBonusQuery = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type ListBonusesQuery = {
  __typename: "ModelBonusConnection";
  items: Array<{
    __typename: "Bonus";
    id: string;
    type?: string | null;
    basePerc?: number | null;
    capitalPerc?: number | null;
    annualPerc?: number | null;
    levelPerc?: number | null;
    contractId?: string | null;
    user?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    date?: string | null;
    total?: number | null;
    status?: BonusStatus | null;
    payDate?: string | null;
    typeEnum?: BonusType | null;
    info?: string | null;
    process?: {
      __typename: "BonusGenerationProcess";
      id: string;
      date?: string | null;
      type?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      stato?: string | null;
      pagamenti?: string | null;
      info?: string | null;
      note?: string | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    userBonusId?: string | null;
    bonusProcessId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncBonusesQuery = {
  __typename: "ModelBonusConnection";
  items: Array<{
    __typename: "Bonus";
    id: string;
    type?: string | null;
    basePerc?: number | null;
    capitalPerc?: number | null;
    annualPerc?: number | null;
    levelPerc?: number | null;
    contractId?: string | null;
    user?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    date?: string | null;
    total?: number | null;
    status?: BonusStatus | null;
    payDate?: string | null;
    typeEnum?: BonusType | null;
    info?: string | null;
    process?: {
      __typename: "BonusGenerationProcess";
      id: string;
      date?: string | null;
      type?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      stato?: string | null;
      pagamenti?: string | null;
      info?: string | null;
      note?: string | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    userBonusId?: string | null;
    bonusProcessId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetContractQuery = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type ListContractsQuery = {
  __typename: "ModelContractConnection";
  items: Array<{
    __typename: "Contract";
    id: string;
    clientId?: string | null;
    notes?: string | null;
    date?: string | null;
    durationInDays?: number | null;
    amount?: number | null;
    fileIdentifier?: string | null;
    file?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    commercial?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    capital?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    percent?: number | null;
    totalWithBounoce?: number | null;
    product?: string | null;
    status?: string | null;
    bonusGenerated?: boolean | null;
    bonusActiveFirstYear?: number | null;
    bonusRecurrence?: number | null;
    extended?: boolean | null;
    extendedFromDate?: string | null;
    extendedBy?: string | null;
    updatedBy?: string | null;
    extendedTimeStamp?: string | null;
    contractYears?: number | null;
    notification?: boolean | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    userContractsAddedId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncContractsQuery = {
  __typename: "ModelContractConnection";
  items: Array<{
    __typename: "Contract";
    id: string;
    clientId?: string | null;
    notes?: string | null;
    date?: string | null;
    durationInDays?: number | null;
    amount?: number | null;
    fileIdentifier?: string | null;
    file?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    commercial?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    capital?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    percent?: number | null;
    totalWithBounoce?: number | null;
    product?: string | null;
    status?: string | null;
    bonusGenerated?: boolean | null;
    bonusActiveFirstYear?: number | null;
    bonusRecurrence?: number | null;
    extended?: boolean | null;
    extendedFromDate?: string | null;
    extendedBy?: string | null;
    updatedBy?: string | null;
    extendedTimeStamp?: string | null;
    contractYears?: number | null;
    notification?: boolean | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    userContractsAddedId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetTeamQuery = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type ListTeamsQuery = {
  __typename: "ModelTeamConnection";
  items: Array<{
    __typename: "Team";
    id: string;
    name: string;
    description?: string | null;
    teammates?: {
      __typename: "ModelUserConnection";
      items: Array<{
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    manager?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    teamManagerId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncTeamsQuery = {
  __typename: "ModelTeamConnection";
  items: Array<{
    __typename: "Team";
    id: string;
    name: string;
    description?: string | null;
    teammates?: {
      __typename: "ModelUserConnection";
      items: Array<{
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    manager?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    teamManagerId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetSupportRequestQuery = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type ListSupportRequestsQuery = {
  __typename: "ModelSupportRequestConnection";
  items: Array<{
    __typename: "SupportRequest";
    id: string;
    agentId?: string | null;
    clientId?: string | null;
    fromId?: string | null;
    fromUser?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    message?: string | null;
    createdAt?: string | null;
    ticket?: {
      __typename: "Ticket";
      id: string;
      title: string;
      client?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      messages?: {
        __typename: "ModelSupportRequestConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ticketStatus?: TicketStatus | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketClientId?: string | null;
    } | null;
    ticketId?: string | null;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketMessagesId?: string | null;
    supportRequestFromUserId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncSupportRequestsQuery = {
  __typename: "ModelSupportRequestConnection";
  items: Array<{
    __typename: "SupportRequest";
    id: string;
    agentId?: string | null;
    clientId?: string | null;
    fromId?: string | null;
    fromUser?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    message?: string | null;
    createdAt?: string | null;
    ticket?: {
      __typename: "Ticket";
      id: string;
      title: string;
      client?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      messages?: {
        __typename: "ModelSupportRequestConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ticketStatus?: TicketStatus | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketClientId?: string | null;
    } | null;
    ticketId?: string | null;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketMessagesId?: string | null;
    supportRequestFromUserId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetTicketQuery = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type ListTicketsQuery = {
  __typename: "ModelTicketConnection";
  items: Array<{
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncTicketsQuery = {
  __typename: "ModelTicketConnection";
  items: Array<{
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetNotificationQuery = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type ListNotificationsQuery = {
  __typename: "ModelNotificationConnection";
  items: Array<{
    __typename: "Notification";
    id: string;
    userId?: string | null;
    msg: string;
    isSeen: boolean;
    isOperator: boolean;
    isAdmin: boolean;
    url?: string | null;
    createdAt?: string | null;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncNotificationsQuery = {
  __typename: "ModelNotificationConnection";
  items: Array<{
    __typename: "Notification";
    id: string;
    userId?: string | null;
    msg: string;
    isSeen: boolean;
    isOperator: boolean;
    isAdmin: boolean;
    url?: string | null;
    createdAt?: string | null;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type GetBonusGenerationProcessQuery = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type ListBonusGenerationProcessesQuery = {
  __typename: "ModelBonusGenerationProcessConnection";
  items: Array<{
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type SyncBonusGenerationProcessesQuery = {
  __typename: "ModelBonusGenerationProcessConnection";
  items: Array<{
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null>;
  nextToken?: string | null;
  startedAt?: number | null;
};

export type OnCreateUserSubscription = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnUpdateUserSubscription = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnDeleteUserSubscription = {
  __typename: "User";
  id: string;
  name?: string | null;
  lastname?: string | null;
  teamID?: string | null;
  email: string;
  phoneNumber?: string | null;
  assignedTo?: string | null;
  addedBy?: string | null;
  role?: string | null;
  permessions?: PermissionType | null;
  notes?: string | null;
  numeroCI?: string | null;
  Bonus?: {
    __typename: "ModelBonusConnection";
    items: Array<{
      __typename: "Bonus";
      id: string;
      type?: string | null;
      basePerc?: number | null;
      capitalPerc?: number | null;
      annualPerc?: number | null;
      levelPerc?: number | null;
      contractId?: string | null;
      user?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      date?: string | null;
      total?: number | null;
      status?: BonusStatus | null;
      payDate?: string | null;
      typeEnum?: BonusType | null;
      info?: string | null;
      process?: {
        __typename: "BonusGenerationProcess";
        id: string;
        date?: string | null;
        type?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        stato?: string | null;
        pagamenti?: string | null;
        info?: string | null;
        note?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userBonusId?: string | null;
      bonusProcessId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ContractsAdded?: {
    __typename: "ModelContractConnection";
    items: Array<{
      __typename: "Contract";
      id: string;
      clientId?: string | null;
      notes?: string | null;
      date?: string | null;
      durationInDays?: number | null;
      amount?: number | null;
      fileIdentifier?: string | null;
      file?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      commercial?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      capital?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      percent?: number | null;
      totalWithBounoce?: number | null;
      product?: string | null;
      status?: string | null;
      bonusGenerated?: boolean | null;
      bonusActiveFirstYear?: number | null;
      bonusRecurrence?: number | null;
      extended?: boolean | null;
      extendedFromDate?: string | null;
      extendedBy?: string | null;
      updatedBy?: string | null;
      extendedTimeStamp?: string | null;
      contractYears?: number | null;
      notification?: boolean | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      userContractsAddedId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  cf?: string | null;
  managerFeePercent?: number | null;
  FcartaIdentita?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcodiceFiscale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpatenteGuida?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FverificaCasellare?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidednza?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcontrattoInvestimento?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcartaIdentitaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprovaResidenzaAutenticata?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdeclarationIndividual?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprofessionalReference?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FcurricolumVitae?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FprorogaContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FpassaggioContrattuale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FdocumentoSuccessione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FquitanzaLiquidazione?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fmanleva?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FapplicationRelease?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FwidthrowForm?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloParziale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  FsvincoloTotale?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra1?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  Fextra2?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  profileImg?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  TRC20?: string | null;
  TRC20Active?: boolean | null;
  device_id?: string | null;
  oneSignalEmailId?: string | null;
  directExcutiveBonus?: boolean | null;
  directSeniorBonus?: boolean | null;
  directLeaderBonus?: boolean | null;
  downlineExcutiveBonus?: boolean | null;
  downlineSeniorBonus?: boolean | null;
  downlineLeaderBonus?: boolean | null;
  notification?: boolean | null;
  totalActiveContracts?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnCreateFaqSubscription = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnUpdateFaqSubscription = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnDeleteFaqSubscription = {
  __typename: "Faq";
  id: string;
  question?: string | null;
  answer?: string | null;
  category?: string | null;
  order?: number | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnCreateBonusSubscription = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type OnUpdateBonusSubscription = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type OnDeleteBonusSubscription = {
  __typename: "Bonus";
  id: string;
  type?: string | null;
  basePerc?: number | null;
  capitalPerc?: number | null;
  annualPerc?: number | null;
  levelPerc?: number | null;
  contractId?: string | null;
  user?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  date?: string | null;
  total?: number | null;
  status?: BonusStatus | null;
  payDate?: string | null;
  typeEnum?: BonusType | null;
  info?: string | null;
  process?: {
    __typename: "BonusGenerationProcess";
    id: string;
    date?: string | null;
    type?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    stato?: string | null;
    pagamenti?: string | null;
    info?: string | null;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userBonusId?: string | null;
  bonusProcessId?: string | null;
};

export type OnCreateContractSubscription = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type OnUpdateContractSubscription = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type OnDeleteContractSubscription = {
  __typename: "Contract";
  id: string;
  clientId?: string | null;
  notes?: string | null;
  date?: string | null;
  durationInDays?: number | null;
  amount?: number | null;
  fileIdentifier?: string | null;
  file?: {
    __typename: "S3Object";
    bucket?: string | null;
    region?: string | null;
    key?: string | null;
    validated?: boolean | null;
    updateDate?: string | null;
  } | null;
  commercial?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  capital?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  percent?: number | null;
  totalWithBounoce?: number | null;
  product?: string | null;
  status?: string | null;
  bonusGenerated?: boolean | null;
  bonusActiveFirstYear?: number | null;
  bonusRecurrence?: number | null;
  extended?: boolean | null;
  extendedFromDate?: string | null;
  extendedBy?: string | null;
  updatedBy?: string | null;
  extendedTimeStamp?: string | null;
  contractYears?: number | null;
  notification?: boolean | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  userContractsAddedId?: string | null;
};

export type OnCreateTeamSubscription = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type OnUpdateTeamSubscription = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type OnDeleteTeamSubscription = {
  __typename: "Team";
  id: string;
  name: string;
  description?: string | null;
  teammates?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  manager?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  teamManagerId?: string | null;
};

export type OnCreateSupportRequestSubscription = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type OnUpdateSupportRequestSubscription = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type OnDeleteSupportRequestSubscription = {
  __typename: "SupportRequest";
  id: string;
  agentId?: string | null;
  clientId?: string | null;
  fromId?: string | null;
  fromUser?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  message?: string | null;
  createdAt?: string | null;
  ticket?: {
    __typename: "Ticket";
    id: string;
    title: string;
    client?: {
      __typename: "User";
      id: string;
      name?: string | null;
      lastname?: string | null;
      teamID?: string | null;
      email: string;
      phoneNumber?: string | null;
      assignedTo?: string | null;
      addedBy?: string | null;
      role?: string | null;
      permessions?: PermissionType | null;
      notes?: string | null;
      numeroCI?: string | null;
      Bonus?: {
        __typename: "ModelBonusConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      ContractsAdded?: {
        __typename: "ModelContractConnection";
        nextToken?: string | null;
        startedAt?: number | null;
      } | null;
      cf?: string | null;
      managerFeePercent?: number | null;
      FcartaIdentita?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcodiceFiscale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpatenteGuida?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FverificaCasellare?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidednza?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcontrattoInvestimento?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcartaIdentitaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprovaResidenzaAutenticata?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdeclarationIndividual?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprofessionalReference?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FcurricolumVitae?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FprorogaContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FpassaggioContrattuale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FdocumentoSuccessione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FquitanzaLiquidazione?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fmanleva?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FapplicationRelease?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FwidthrowForm?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloParziale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      FsvincoloTotale?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra1?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      Fextra2?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      profileImg?: {
        __typename: "S3Object";
        bucket?: string | null;
        region?: string | null;
        key?: string | null;
        validated?: boolean | null;
        updateDate?: string | null;
      } | null;
      TRC20?: string | null;
      TRC20Active?: boolean | null;
      device_id?: string | null;
      oneSignalEmailId?: string | null;
      directExcutiveBonus?: boolean | null;
      directSeniorBonus?: boolean | null;
      directLeaderBonus?: boolean | null;
      downlineExcutiveBonus?: boolean | null;
      downlineSeniorBonus?: boolean | null;
      downlineLeaderBonus?: boolean | null;
      notification?: boolean | null;
      totalActiveContracts?: number | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    } | null;
    messages?: {
      __typename: "ModelSupportRequestConnection";
      items: Array<{
        __typename: "SupportRequest";
        id: string;
        agentId?: string | null;
        clientId?: string | null;
        fromId?: string | null;
        message?: string | null;
        createdAt?: string | null;
        ticketId?: string | null;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketMessagesId?: string | null;
        supportRequestFromUserId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ticketStatus?: TicketStatus | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
    ticketClientId?: string | null;
  } | null;
  ticketId?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketMessagesId?: string | null;
  supportRequestFromUserId?: string | null;
};

export type OnCreateTicketSubscription = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type OnUpdateTicketSubscription = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type OnDeleteTicketSubscription = {
  __typename: "Ticket";
  id: string;
  title: string;
  client?: {
    __typename: "User";
    id: string;
    name?: string | null;
    lastname?: string | null;
    teamID?: string | null;
    email: string;
    phoneNumber?: string | null;
    assignedTo?: string | null;
    addedBy?: string | null;
    role?: string | null;
    permessions?: PermissionType | null;
    notes?: string | null;
    numeroCI?: string | null;
    Bonus?: {
      __typename: "ModelBonusConnection";
      items: Array<{
        __typename: "Bonus";
        id: string;
        type?: string | null;
        basePerc?: number | null;
        capitalPerc?: number | null;
        annualPerc?: number | null;
        levelPerc?: number | null;
        contractId?: string | null;
        date?: string | null;
        total?: number | null;
        status?: BonusStatus | null;
        payDate?: string | null;
        typeEnum?: BonusType | null;
        info?: string | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userBonusId?: string | null;
        bonusProcessId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    ContractsAdded?: {
      __typename: "ModelContractConnection";
      items: Array<{
        __typename: "Contract";
        id: string;
        clientId?: string | null;
        notes?: string | null;
        date?: string | null;
        durationInDays?: number | null;
        amount?: number | null;
        fileIdentifier?: string | null;
        capital?: number | null;
        startDate?: string | null;
        endDate?: string | null;
        percent?: number | null;
        totalWithBounoce?: number | null;
        product?: string | null;
        status?: string | null;
        bonusGenerated?: boolean | null;
        bonusActiveFirstYear?: number | null;
        bonusRecurrence?: number | null;
        extended?: boolean | null;
        extendedFromDate?: string | null;
        extendedBy?: string | null;
        updatedBy?: string | null;
        extendedTimeStamp?: string | null;
        contractYears?: number | null;
        notification?: boolean | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        userContractsAddedId?: string | null;
      } | null>;
      nextToken?: string | null;
      startedAt?: number | null;
    } | null;
    cf?: string | null;
    managerFeePercent?: number | null;
    FcartaIdentita?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcodiceFiscale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpatenteGuida?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FverificaCasellare?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidednza?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcontrattoInvestimento?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcartaIdentitaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprovaResidenzaAutenticata?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdeclarationIndividual?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprofessionalReference?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FcurricolumVitae?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FprorogaContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FpassaggioContrattuale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FdocumentoSuccessione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FquitanzaLiquidazione?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fmanleva?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FapplicationRelease?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FwidthrowForm?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloParziale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    FsvincoloTotale?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra1?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    Fextra2?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    profileImg?: {
      __typename: "S3Object";
      bucket?: string | null;
      region?: string | null;
      key?: string | null;
      validated?: boolean | null;
      updateDate?: string | null;
    } | null;
    TRC20?: string | null;
    TRC20Active?: boolean | null;
    device_id?: string | null;
    oneSignalEmailId?: string | null;
    directExcutiveBonus?: boolean | null;
    directSeniorBonus?: boolean | null;
    directLeaderBonus?: boolean | null;
    downlineExcutiveBonus?: boolean | null;
    downlineSeniorBonus?: boolean | null;
    downlineLeaderBonus?: boolean | null;
    notification?: boolean | null;
    totalActiveContracts?: number | null;
    createdAt: string;
    updatedAt: string;
    _version: number;
    _deleted?: boolean | null;
    _lastChangedAt: number;
  } | null;
  messages?: {
    __typename: "ModelSupportRequestConnection";
    items: Array<{
      __typename: "SupportRequest";
      id: string;
      agentId?: string | null;
      clientId?: string | null;
      fromId?: string | null;
      fromUser?: {
        __typename: "User";
        id: string;
        name?: string | null;
        lastname?: string | null;
        teamID?: string | null;
        email: string;
        phoneNumber?: string | null;
        assignedTo?: string | null;
        addedBy?: string | null;
        role?: string | null;
        permessions?: PermissionType | null;
        notes?: string | null;
        numeroCI?: string | null;
        cf?: string | null;
        managerFeePercent?: number | null;
        TRC20?: string | null;
        TRC20Active?: boolean | null;
        device_id?: string | null;
        oneSignalEmailId?: string | null;
        directExcutiveBonus?: boolean | null;
        directSeniorBonus?: boolean | null;
        directLeaderBonus?: boolean | null;
        downlineExcutiveBonus?: boolean | null;
        downlineSeniorBonus?: boolean | null;
        downlineLeaderBonus?: boolean | null;
        notification?: boolean | null;
        totalActiveContracts?: number | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
      } | null;
      message?: string | null;
      createdAt?: string | null;
      ticket?: {
        __typename: "Ticket";
        id: string;
        title: string;
        ticketStatus?: TicketStatus | null;
        createdAt: string;
        updatedAt: string;
        _version: number;
        _deleted?: boolean | null;
        _lastChangedAt: number;
        ticketClientId?: string | null;
      } | null;
      ticketId?: string | null;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
      ticketMessagesId?: string | null;
      supportRequestFromUserId?: string | null;
    } | null>;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  ticketStatus?: TicketStatus | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
  ticketClientId?: string | null;
};

export type OnCreateNotificationSubscription = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnUpdateNotificationSubscription = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnDeleteNotificationSubscription = {
  __typename: "Notification";
  id: string;
  userId?: string | null;
  msg: string;
  isSeen: boolean;
  isOperator: boolean;
  isAdmin: boolean;
  url?: string | null;
  createdAt?: string | null;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnCreateBonusGenerationProcessSubscription = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnUpdateBonusGenerationProcessSubscription = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

export type OnDeleteBonusGenerationProcessSubscription = {
  __typename: "BonusGenerationProcess";
  id: string;
  date?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  stato?: string | null;
  pagamenti?: string | null;
  info?: string | null;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async CreateUser(
    input: CreateUserInput,
    condition?: ModelUserConditionInput
  ): Promise<CreateUserMutation> {
    const statement = `mutation CreateUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
        createUser(input: $input, condition: $condition) {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateUserMutation>response.data.createUser;
  }
  async UpdateUser(
    input: UpdateUserInput,
    condition?: ModelUserConditionInput
  ): Promise<UpdateUserMutation> {
    const statement = `mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
        updateUser(input: $input, condition: $condition) {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateUserMutation>response.data.updateUser;
  }
  async DeleteUser(
    input: DeleteUserInput,
    condition?: ModelUserConditionInput
  ): Promise<DeleteUserMutation> {
    const statement = `mutation DeleteUser($input: DeleteUserInput!, $condition: ModelUserConditionInput) {
        deleteUser(input: $input, condition: $condition) {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteUserMutation>response.data.deleteUser;
  }
  async CreateFaq(
    input: CreateFaqInput,
    condition?: ModelFaqConditionInput
  ): Promise<CreateFaqMutation> {
    const statement = `mutation CreateFaq($input: CreateFaqInput!, $condition: ModelFaqConditionInput) {
        createFaq(input: $input, condition: $condition) {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFaqMutation>response.data.createFaq;
  }
  async UpdateFaq(
    input: UpdateFaqInput,
    condition?: ModelFaqConditionInput
  ): Promise<UpdateFaqMutation> {
    const statement = `mutation UpdateFaq($input: UpdateFaqInput!, $condition: ModelFaqConditionInput) {
        updateFaq(input: $input, condition: $condition) {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFaqMutation>response.data.updateFaq;
  }
  async DeleteFaq(
    input: DeleteFaqInput,
    condition?: ModelFaqConditionInput
  ): Promise<DeleteFaqMutation> {
    const statement = `mutation DeleteFaq($input: DeleteFaqInput!, $condition: ModelFaqConditionInput) {
        deleteFaq(input: $input, condition: $condition) {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFaqMutation>response.data.deleteFaq;
  }
  async CreateBonus(
    input: CreateBonusInput,
    condition?: ModelBonusConditionInput
  ): Promise<CreateBonusMutation> {
    const statement = `mutation CreateBonus($input: CreateBonusInput!, $condition: ModelBonusConditionInput) {
        createBonus(input: $input, condition: $condition) {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateBonusMutation>response.data.createBonus;
  }
  async UpdateBonus(
    input: UpdateBonusInput,
    condition?: ModelBonusConditionInput
  ): Promise<UpdateBonusMutation> {
    const statement = `mutation UpdateBonus($input: UpdateBonusInput!, $condition: ModelBonusConditionInput) {
        updateBonus(input: $input, condition: $condition) {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateBonusMutation>response.data.updateBonus;
  }
  async DeleteBonus(
    input: DeleteBonusInput,
    condition?: ModelBonusConditionInput
  ): Promise<DeleteBonusMutation> {
    const statement = `mutation DeleteBonus($input: DeleteBonusInput!, $condition: ModelBonusConditionInput) {
        deleteBonus(input: $input, condition: $condition) {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteBonusMutation>response.data.deleteBonus;
  }
  async CreateContract(
    input: CreateContractInput,
    condition?: ModelContractConditionInput
  ): Promise<CreateContractMutation> {
    const statement = `mutation CreateContract($input: CreateContractInput!, $condition: ModelContractConditionInput) {
        createContract(input: $input, condition: $condition) {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateContractMutation>response.data.createContract;
  }
  async UpdateContract(
    input: UpdateContractInput,
    condition?: ModelContractConditionInput
  ): Promise<UpdateContractMutation> {
    const statement = `mutation UpdateContract($input: UpdateContractInput!, $condition: ModelContractConditionInput) {
        updateContract(input: $input, condition: $condition) {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateContractMutation>response.data.updateContract;
  }
  async DeleteContract(
    input: DeleteContractInput,
    condition?: ModelContractConditionInput
  ): Promise<DeleteContractMutation> {
    const statement = `mutation DeleteContract($input: DeleteContractInput!, $condition: ModelContractConditionInput) {
        deleteContract(input: $input, condition: $condition) {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteContractMutation>response.data.deleteContract;
  }
  async CreateTeam(
    input: CreateTeamInput,
    condition?: ModelTeamConditionInput
  ): Promise<CreateTeamMutation> {
    const statement = `mutation CreateTeam($input: CreateTeamInput!, $condition: ModelTeamConditionInput) {
        createTeam(input: $input, condition: $condition) {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTeamMutation>response.data.createTeam;
  }
  async UpdateTeam(
    input: UpdateTeamInput,
    condition?: ModelTeamConditionInput
  ): Promise<UpdateTeamMutation> {
    const statement = `mutation UpdateTeam($input: UpdateTeamInput!, $condition: ModelTeamConditionInput) {
        updateTeam(input: $input, condition: $condition) {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateTeamMutation>response.data.updateTeam;
  }
  async DeleteTeam(
    input: DeleteTeamInput,
    condition?: ModelTeamConditionInput
  ): Promise<DeleteTeamMutation> {
    const statement = `mutation DeleteTeam($input: DeleteTeamInput!, $condition: ModelTeamConditionInput) {
        deleteTeam(input: $input, condition: $condition) {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteTeamMutation>response.data.deleteTeam;
  }
  async CreateSupportRequest(
    input: CreateSupportRequestInput,
    condition?: ModelSupportRequestConditionInput
  ): Promise<CreateSupportRequestMutation> {
    const statement = `mutation CreateSupportRequest($input: CreateSupportRequestInput!, $condition: ModelSupportRequestConditionInput) {
        createSupportRequest(input: $input, condition: $condition) {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSupportRequestMutation>response.data.createSupportRequest;
  }
  async UpdateSupportRequest(
    input: UpdateSupportRequestInput,
    condition?: ModelSupportRequestConditionInput
  ): Promise<UpdateSupportRequestMutation> {
    const statement = `mutation UpdateSupportRequest($input: UpdateSupportRequestInput!, $condition: ModelSupportRequestConditionInput) {
        updateSupportRequest(input: $input, condition: $condition) {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSupportRequestMutation>response.data.updateSupportRequest;
  }
  async DeleteSupportRequest(
    input: DeleteSupportRequestInput,
    condition?: ModelSupportRequestConditionInput
  ): Promise<DeleteSupportRequestMutation> {
    const statement = `mutation DeleteSupportRequest($input: DeleteSupportRequestInput!, $condition: ModelSupportRequestConditionInput) {
        deleteSupportRequest(input: $input, condition: $condition) {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSupportRequestMutation>response.data.deleteSupportRequest;
  }
  async CreateTicket(
    input: CreateTicketInput,
    condition?: ModelTicketConditionInput
  ): Promise<CreateTicketMutation> {
    const statement = `mutation CreateTicket($input: CreateTicketInput!, $condition: ModelTicketConditionInput) {
        createTicket(input: $input, condition: $condition) {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTicketMutation>response.data.createTicket;
  }
  async UpdateTicket(
    input: UpdateTicketInput,
    condition?: ModelTicketConditionInput
  ): Promise<UpdateTicketMutation> {
    const statement = `mutation UpdateTicket($input: UpdateTicketInput!, $condition: ModelTicketConditionInput) {
        updateTicket(input: $input, condition: $condition) {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateTicketMutation>response.data.updateTicket;
  }
  async DeleteTicket(
    input: DeleteTicketInput,
    condition?: ModelTicketConditionInput
  ): Promise<DeleteTicketMutation> {
    const statement = `mutation DeleteTicket($input: DeleteTicketInput!, $condition: ModelTicketConditionInput) {
        deleteTicket(input: $input, condition: $condition) {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteTicketMutation>response.data.deleteTicket;
  }
  async CreateNotification(
    input: CreateNotificationInput,
    condition?: ModelNotificationConditionInput
  ): Promise<CreateNotificationMutation> {
    const statement = `mutation CreateNotification($input: CreateNotificationInput!, $condition: ModelNotificationConditionInput) {
        createNotification(input: $input, condition: $condition) {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNotificationMutation>response.data.createNotification;
  }
  async UpdateNotification(
    input: UpdateNotificationInput,
    condition?: ModelNotificationConditionInput
  ): Promise<UpdateNotificationMutation> {
    const statement = `mutation UpdateNotification($input: UpdateNotificationInput!, $condition: ModelNotificationConditionInput) {
        updateNotification(input: $input, condition: $condition) {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNotificationMutation>response.data.updateNotification;
  }
  async DeleteNotification(
    input: DeleteNotificationInput,
    condition?: ModelNotificationConditionInput
  ): Promise<DeleteNotificationMutation> {
    const statement = `mutation DeleteNotification($input: DeleteNotificationInput!, $condition: ModelNotificationConditionInput) {
        deleteNotification(input: $input, condition: $condition) {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNotificationMutation>response.data.deleteNotification;
  }
  async CreateBonusGenerationProcess(
    input: CreateBonusGenerationProcessInput,
    condition?: ModelBonusGenerationProcessConditionInput
  ): Promise<CreateBonusGenerationProcessMutation> {
    const statement = `mutation CreateBonusGenerationProcess($input: CreateBonusGenerationProcessInput!, $condition: ModelBonusGenerationProcessConditionInput) {
        createBonusGenerationProcess(input: $input, condition: $condition) {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateBonusGenerationProcessMutation>(
      response.data.createBonusGenerationProcess
    );
  }
  async UpdateBonusGenerationProcess(
    input: UpdateBonusGenerationProcessInput,
    condition?: ModelBonusGenerationProcessConditionInput
  ): Promise<UpdateBonusGenerationProcessMutation> {
    const statement = `mutation UpdateBonusGenerationProcess($input: UpdateBonusGenerationProcessInput!, $condition: ModelBonusGenerationProcessConditionInput) {
        updateBonusGenerationProcess(input: $input, condition: $condition) {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateBonusGenerationProcessMutation>(
      response.data.updateBonusGenerationProcess
    );
  }
  async DeleteBonusGenerationProcess(
    input: DeleteBonusGenerationProcessInput,
    condition?: ModelBonusGenerationProcessConditionInput
  ): Promise<DeleteBonusGenerationProcessMutation> {
    const statement = `mutation DeleteBonusGenerationProcess($input: DeleteBonusGenerationProcessInput!, $condition: ModelBonusGenerationProcessConditionInput) {
        deleteBonusGenerationProcess(input: $input, condition: $condition) {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteBonusGenerationProcessMutation>(
      response.data.deleteBonusGenerationProcess
    );
  }
  async GetUser(id: string): Promise<GetUserQuery> {
    const statement = `query GetUser($id: ID!) {
        getUser(id: $id) {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserQuery>response.data.getUser;
  }
  async ListUsers(
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListUsersQuery> {
    const statement = `query ListUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListUsersQuery>response.data.listUsers;
  }
  async SyncUsers(
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncUsersQuery> {
    const statement = `query SyncUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncUsers(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncUsersQuery>response.data.syncUsers;
  }
  async UserByEmail(
    email: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<UserByEmailQuery> {
    const statement = `query UserByEmail($email: String!, $sortDirection: ModelSortDirection, $filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        UserByEmail(email: $email, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      email
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UserByEmailQuery>response.data.UserByEmail;
  }
  async GetFaq(id: string): Promise<GetFaqQuery> {
    const statement = `query GetFaq($id: ID!) {
        getFaq(id: $id) {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFaqQuery>response.data.getFaq;
  }
  async ListFaqs(
    filter?: ModelFaqFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFaqsQuery> {
    const statement = `query ListFaqs($filter: ModelFaqFilterInput, $limit: Int, $nextToken: String) {
        listFaqs(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            question
            answer
            category
            order
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFaqsQuery>response.data.listFaqs;
  }
  async SyncFaqs(
    filter?: ModelFaqFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncFaqsQuery> {
    const statement = `query SyncFaqs($filter: ModelFaqFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncFaqs(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            question
            answer
            category
            order
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncFaqsQuery>response.data.syncFaqs;
  }
  async GetBonus(id: string): Promise<GetBonusQuery> {
    const statement = `query GetBonus($id: ID!) {
        getBonus(id: $id) {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetBonusQuery>response.data.getBonus;
  }
  async ListBonuses(
    filter?: ModelBonusFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListBonusesQuery> {
    const statement = `query ListBonuses($filter: ModelBonusFilterInput, $limit: Int, $nextToken: String) {
        listBonuses(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            basePerc
            capitalPerc
            annualPerc
            levelPerc
            contractId
            user {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            date
            total
            status
            payDate
            typeEnum
            info
            process {
              __typename
              id
              date
              type
              startDate
              endDate
              stato
              pagamenti
              info
              note
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            userBonusId
            bonusProcessId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListBonusesQuery>response.data.listBonuses;
  }
  async SyncBonuses(
    filter?: ModelBonusFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncBonusesQuery> {
    const statement = `query SyncBonuses($filter: ModelBonusFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncBonuses(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            type
            basePerc
            capitalPerc
            annualPerc
            levelPerc
            contractId
            user {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            date
            total
            status
            payDate
            typeEnum
            info
            process {
              __typename
              id
              date
              type
              startDate
              endDate
              stato
              pagamenti
              info
              note
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            userBonusId
            bonusProcessId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncBonusesQuery>response.data.syncBonuses;
  }
  async GetContract(id: string): Promise<GetContractQuery> {
    const statement = `query GetContract($id: ID!) {
        getContract(id: $id) {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetContractQuery>response.data.getContract;
  }
  async ListContracts(
    filter?: ModelContractFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListContractsQuery> {
    const statement = `query ListContracts($filter: ModelContractFilterInput, $limit: Int, $nextToken: String) {
        listContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            clientId
            notes
            date
            durationInDays
            amount
            fileIdentifier
            file {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            commercial {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            capital
            startDate
            endDate
            percent
            totalWithBounoce
            product
            status
            bonusGenerated
            bonusActiveFirstYear
            bonusRecurrence
            extended
            extendedFromDate
            extendedBy
            updatedBy
            extendedTimeStamp
            contractYears
            notification
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            userContractsAddedId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListContractsQuery>response.data.listContracts;
  }
  async SyncContracts(
    filter?: ModelContractFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncContractsQuery> {
    const statement = `query SyncContracts($filter: ModelContractFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncContracts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            clientId
            notes
            date
            durationInDays
            amount
            fileIdentifier
            file {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            commercial {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            capital
            startDate
            endDate
            percent
            totalWithBounoce
            product
            status
            bonusGenerated
            bonusActiveFirstYear
            bonusRecurrence
            extended
            extendedFromDate
            extendedBy
            updatedBy
            extendedTimeStamp
            contractYears
            notification
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            userContractsAddedId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncContractsQuery>response.data.syncContracts;
  }
  async GetTeam(id: string): Promise<GetTeamQuery> {
    const statement = `query GetTeam($id: ID!) {
        getTeam(id: $id) {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetTeamQuery>response.data.getTeam;
  }
  async ListTeams(
    filter?: ModelTeamFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTeamsQuery> {
    const statement = `query ListTeams($filter: ModelTeamFilterInput, $limit: Int, $nextToken: String) {
        listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            description
            teammates {
              __typename
              items {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              nextToken
              startedAt
            }
            manager {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            teamManagerId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTeamsQuery>response.data.listTeams;
  }
  async SyncTeams(
    filter?: ModelTeamFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncTeamsQuery> {
    const statement = `query SyncTeams($filter: ModelTeamFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncTeams(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            name
            description
            teammates {
              __typename
              items {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              nextToken
              startedAt
            }
            manager {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            teamManagerId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncTeamsQuery>response.data.syncTeams;
  }
  async GetSupportRequest(id: string): Promise<GetSupportRequestQuery> {
    const statement = `query GetSupportRequest($id: ID!) {
        getSupportRequest(id: $id) {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSupportRequestQuery>response.data.getSupportRequest;
  }
  async ListSupportRequests(
    filter?: ModelSupportRequestFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSupportRequestsQuery> {
    const statement = `query ListSupportRequests($filter: ModelSupportRequestFilterInput, $limit: Int, $nextToken: String) {
        listSupportRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            agentId
            clientId
            fromId
            fromUser {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            message
            createdAt
            ticket {
              __typename
              id
              title
              client {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              messages {
                __typename
                nextToken
                startedAt
              }
              ticketStatus
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketClientId
            }
            ticketId
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketMessagesId
            supportRequestFromUserId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSupportRequestsQuery>response.data.listSupportRequests;
  }
  async SyncSupportRequests(
    filter?: ModelSupportRequestFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncSupportRequestsQuery> {
    const statement = `query SyncSupportRequests($filter: ModelSupportRequestFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncSupportRequests(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            agentId
            clientId
            fromId
            fromUser {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            message
            createdAt
            ticket {
              __typename
              id
              title
              client {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              messages {
                __typename
                nextToken
                startedAt
              }
              ticketStatus
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketClientId
            }
            ticketId
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketMessagesId
            supportRequestFromUserId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncSupportRequestsQuery>response.data.syncSupportRequests;
  }
  async GetTicket(id: string): Promise<GetTicketQuery> {
    const statement = `query GetTicket($id: ID!) {
        getTicket(id: $id) {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetTicketQuery>response.data.getTicket;
  }
  async ListTickets(
    filter?: ModelTicketFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTicketsQuery> {
    const statement = `query ListTickets($filter: ModelTicketFilterInput, $limit: Int, $nextToken: String) {
        listTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTicketsQuery>response.data.listTickets;
  }
  async SyncTickets(
    filter?: ModelTicketFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncTicketsQuery> {
    const statement = `query SyncTickets($filter: ModelTicketFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncTickets(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncTicketsQuery>response.data.syncTickets;
  }
  async GetNotification(id: string): Promise<GetNotificationQuery> {
    const statement = `query GetNotification($id: ID!) {
        getNotification(id: $id) {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNotificationQuery>response.data.getNotification;
  }
  async ListNotifications(
    filter?: ModelNotificationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNotificationsQuery> {
    const statement = `query ListNotifications($filter: ModelNotificationFilterInput, $limit: Int, $nextToken: String) {
        listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userId
            msg
            isSeen
            isOperator
            isAdmin
            url
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNotificationsQuery>response.data.listNotifications;
  }
  async SyncNotifications(
    filter?: ModelNotificationFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncNotificationsQuery> {
    const statement = `query SyncNotifications($filter: ModelNotificationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncNotifications(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            userId
            msg
            isSeen
            isOperator
            isAdmin
            url
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncNotificationsQuery>response.data.syncNotifications;
  }
  async GetBonusGenerationProcess(
    id: string
  ): Promise<GetBonusGenerationProcessQuery> {
    const statement = `query GetBonusGenerationProcess($id: ID!) {
        getBonusGenerationProcess(id: $id) {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetBonusGenerationProcessQuery>(
      response.data.getBonusGenerationProcess
    );
  }
  async ListBonusGenerationProcesses(
    filter?: ModelBonusGenerationProcessFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListBonusGenerationProcessesQuery> {
    const statement = `query ListBonusGenerationProcesses($filter: ModelBonusGenerationProcessFilterInput, $limit: Int, $nextToken: String) {
        listBonusGenerationProcesses(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListBonusGenerationProcessesQuery>(
      response.data.listBonusGenerationProcesses
    );
  }
  async SyncBonusGenerationProcesses(
    filter?: ModelBonusGenerationProcessFilterInput,
    limit?: number,
    nextToken?: string,
    lastSync?: number
  ): Promise<SyncBonusGenerationProcessesQuery> {
    const statement = `query SyncBonusGenerationProcesses($filter: ModelBonusGenerationProcessFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
        syncBonusGenerationProcesses(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
          __typename
          items {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (lastSync) {
      gqlAPIServiceArguments.lastSync = lastSync;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SyncBonusGenerationProcessesQuery>(
      response.data.syncBonusGenerationProcesses
    );
  }
  OnCreateUserListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateUser">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateUser {
        onCreateUser {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateUser">>
  >;

  OnUpdateUserListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateUser">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateUser {
        onUpdateUser {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateUser">>
  >;

  OnDeleteUserListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteUser">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteUser {
        onDeleteUser {
          __typename
          id
          name
          lastname
          teamID
          email
          phoneNumber
          assignedTo
          addedBy
          role
          permessions
          notes
          numeroCI
          Bonus {
            __typename
            items {
              __typename
              id
              type
              basePerc
              capitalPerc
              annualPerc
              levelPerc
              contractId
              user {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              date
              total
              status
              payDate
              typeEnum
              info
              process {
                __typename
                id
                date
                type
                startDate
                endDate
                stato
                pagamenti
                info
                note
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userBonusId
              bonusProcessId
            }
            nextToken
            startedAt
          }
          ContractsAdded {
            __typename
            items {
              __typename
              id
              clientId
              notes
              date
              durationInDays
              amount
              fileIdentifier
              file {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              commercial {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              capital
              startDate
              endDate
              percent
              totalWithBounoce
              product
              status
              bonusGenerated
              bonusActiveFirstYear
              bonusRecurrence
              extended
              extendedFromDate
              extendedBy
              updatedBy
              extendedTimeStamp
              contractYears
              notification
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              userContractsAddedId
            }
            nextToken
            startedAt
          }
          cf
          managerFeePercent
          FcartaIdentita {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcodiceFiscale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpatenteGuida {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FverificaCasellare {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidednza {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcontrattoInvestimento {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcartaIdentitaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprovaResidenzaAutenticata {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdeclarationIndividual {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprofessionalReference {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FcurricolumVitae {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FprorogaContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FpassaggioContrattuale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FdocumentoSuccessione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FquitanzaLiquidazione {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fmanleva {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FapplicationRelease {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FwidthrowForm {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloParziale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          FsvincoloTotale {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra1 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          Fextra2 {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          profileImg {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          TRC20
          TRC20Active
          device_id
          oneSignalEmailId
          directExcutiveBonus
          directSeniorBonus
          directLeaderBonus
          downlineExcutiveBonus
          downlineSeniorBonus
          downlineLeaderBonus
          notification
          totalActiveContracts
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteUser">>
  >;

  OnCreateFaqListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFaq">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateFaq {
        onCreateFaq {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFaq">>
  >;

  OnUpdateFaqListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFaq">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateFaq {
        onUpdateFaq {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFaq">>
  >;

  OnDeleteFaqListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteFaq">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteFaq {
        onDeleteFaq {
          __typename
          id
          question
          answer
          category
          order
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteFaq">>
  >;

  OnCreateBonusListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateBonus">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateBonus {
        onCreateBonus {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateBonus">>
  >;

  OnUpdateBonusListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateBonus">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateBonus {
        onUpdateBonus {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateBonus">>
  >;

  OnDeleteBonusListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteBonus">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteBonus {
        onDeleteBonus {
          __typename
          id
          type
          basePerc
          capitalPerc
          annualPerc
          levelPerc
          contractId
          user {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          date
          total
          status
          payDate
          typeEnum
          info
          process {
            __typename
            id
            date
            type
            startDate
            endDate
            stato
            pagamenti
            info
            note
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userBonusId
          bonusProcessId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteBonus">>
  >;

  OnCreateContractListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateContract">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateContract {
        onCreateContract {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateContract">>
  >;

  OnUpdateContractListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateContract">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateContract {
        onUpdateContract {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateContract">>
  >;

  OnDeleteContractListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteContract">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteContract {
        onDeleteContract {
          __typename
          id
          clientId
          notes
          date
          durationInDays
          amount
          fileIdentifier
          file {
            __typename
            bucket
            region
            key
            validated
            updateDate
          }
          commercial {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          capital
          startDate
          endDate
          percent
          totalWithBounoce
          product
          status
          bonusGenerated
          bonusActiveFirstYear
          bonusRecurrence
          extended
          extendedFromDate
          extendedBy
          updatedBy
          extendedTimeStamp
          contractYears
          notification
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userContractsAddedId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteContract">>
  >;

  OnCreateTeamListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTeam">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateTeam {
        onCreateTeam {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTeam">>
  >;

  OnUpdateTeamListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTeam">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateTeam {
        onUpdateTeam {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTeam">>
  >;

  OnDeleteTeamListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTeam">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteTeam {
        onDeleteTeam {
          __typename
          id
          name
          description
          teammates {
            __typename
            items {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            nextToken
            startedAt
          }
          manager {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          teamManagerId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTeam">>
  >;

  OnCreateSupportRequestListener: Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateSupportRequest">
    >
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateSupportRequest {
        onCreateSupportRequest {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateSupportRequest">
    >
  >;

  OnUpdateSupportRequestListener: Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateSupportRequest">
    >
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateSupportRequest {
        onUpdateSupportRequest {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateSupportRequest">
    >
  >;

  OnDeleteSupportRequestListener: Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteSupportRequest">
    >
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteSupportRequest {
        onDeleteSupportRequest {
          __typename
          id
          agentId
          clientId
          fromId
          fromUser {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          message
          createdAt
          ticket {
            __typename
            id
            title
            client {
              __typename
              id
              name
              lastname
              teamID
              email
              phoneNumber
              assignedTo
              addedBy
              role
              permessions
              notes
              numeroCI
              Bonus {
                __typename
                nextToken
                startedAt
              }
              ContractsAdded {
                __typename
                nextToken
                startedAt
              }
              cf
              managerFeePercent
              FcartaIdentita {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcodiceFiscale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpatenteGuida {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FverificaCasellare {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidednza {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcontrattoInvestimento {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcartaIdentitaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprovaResidenzaAutenticata {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdeclarationIndividual {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprofessionalReference {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FcurricolumVitae {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FprorogaContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FpassaggioContrattuale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FdocumentoSuccessione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FquitanzaLiquidazione {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fmanleva {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FapplicationRelease {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FwidthrowForm {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloParziale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              FsvincoloTotale {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra1 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              Fextra2 {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              profileImg {
                __typename
                bucket
                region
                key
                validated
                updateDate
              }
              TRC20
              TRC20Active
              device_id
              oneSignalEmailId
              directExcutiveBonus
              directSeniorBonus
              directLeaderBonus
              downlineExcutiveBonus
              downlineSeniorBonus
              downlineLeaderBonus
              notification
              totalActiveContracts
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
            }
            messages {
              __typename
              items {
                __typename
                id
                agentId
                clientId
                fromId
                message
                createdAt
                ticketId
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketMessagesId
                supportRequestFromUserId
              }
              nextToken
              startedAt
            }
            ticketStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            ticketClientId
          }
          ticketId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketMessagesId
          supportRequestFromUserId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteSupportRequest">
    >
  >;

  OnCreateTicketListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTicket">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateTicket {
        onCreateTicket {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTicket">>
  >;

  OnUpdateTicketListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTicket">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateTicket {
        onUpdateTicket {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTicket">>
  >;

  OnDeleteTicketListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTicket">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteTicket {
        onDeleteTicket {
          __typename
          id
          title
          client {
            __typename
            id
            name
            lastname
            teamID
            email
            phoneNumber
            assignedTo
            addedBy
            role
            permessions
            notes
            numeroCI
            Bonus {
              __typename
              items {
                __typename
                id
                type
                basePerc
                capitalPerc
                annualPerc
                levelPerc
                contractId
                date
                total
                status
                payDate
                typeEnum
                info
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userBonusId
                bonusProcessId
              }
              nextToken
              startedAt
            }
            ContractsAdded {
              __typename
              items {
                __typename
                id
                clientId
                notes
                date
                durationInDays
                amount
                fileIdentifier
                capital
                startDate
                endDate
                percent
                totalWithBounoce
                product
                status
                bonusGenerated
                bonusActiveFirstYear
                bonusRecurrence
                extended
                extendedFromDate
                extendedBy
                updatedBy
                extendedTimeStamp
                contractYears
                notification
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                userContractsAddedId
              }
              nextToken
              startedAt
            }
            cf
            managerFeePercent
            FcartaIdentita {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcodiceFiscale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpatenteGuida {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FverificaCasellare {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidednza {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcontrattoInvestimento {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcartaIdentitaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprovaResidenzaAutenticata {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdeclarationIndividual {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprofessionalReference {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FcurricolumVitae {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FprorogaContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FpassaggioContrattuale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FdocumentoSuccessione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FquitanzaLiquidazione {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fmanleva {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FapplicationRelease {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FwidthrowForm {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloParziale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            FsvincoloTotale {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra1 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            Fextra2 {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            profileImg {
              __typename
              bucket
              region
              key
              validated
              updateDate
            }
            TRC20
            TRC20Active
            device_id
            oneSignalEmailId
            directExcutiveBonus
            directSeniorBonus
            directLeaderBonus
            downlineExcutiveBonus
            downlineSeniorBonus
            downlineLeaderBonus
            notification
            totalActiveContracts
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
          messages {
            __typename
            items {
              __typename
              id
              agentId
              clientId
              fromId
              fromUser {
                __typename
                id
                name
                lastname
                teamID
                email
                phoneNumber
                assignedTo
                addedBy
                role
                permessions
                notes
                numeroCI
                cf
                managerFeePercent
                TRC20
                TRC20Active
                device_id
                oneSignalEmailId
                directExcutiveBonus
                directSeniorBonus
                directLeaderBonus
                downlineExcutiveBonus
                downlineSeniorBonus
                downlineLeaderBonus
                notification
                totalActiveContracts
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
              }
              message
              createdAt
              ticket {
                __typename
                id
                title
                ticketStatus
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                ticketClientId
              }
              ticketId
              updatedAt
              _version
              _deleted
              _lastChangedAt
              ticketMessagesId
              supportRequestFromUserId
            }
            nextToken
            startedAt
          }
          ticketStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ticketClientId
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTicket">>
  >;

  OnCreateNotificationListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNotification">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateNotification {
        onCreateNotification {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNotification">>
  >;

  OnUpdateNotificationListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNotification">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateNotification {
        onUpdateNotification {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNotification">>
  >;

  OnDeleteNotificationListener: Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNotification">>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteNotification {
        onDeleteNotification {
          __typename
          id
          userId
          msg
          isSeen
          isOperator
          isAdmin
          url
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNotification">>
  >;

  OnCreateBonusGenerationProcessListener: Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateBonusGenerationProcess">
    >
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateBonusGenerationProcess {
        onCreateBonusGenerationProcess {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateBonusGenerationProcess">
    >
  >;

  OnUpdateBonusGenerationProcessListener: Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateBonusGenerationProcess">
    >
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateBonusGenerationProcess {
        onUpdateBonusGenerationProcess {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateBonusGenerationProcess">
    >
  >;

  OnDeleteBonusGenerationProcessListener: Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteBonusGenerationProcess">
    >
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteBonusGenerationProcess {
        onDeleteBonusGenerationProcess {
          __typename
          id
          date
          type
          startDate
          endDate
          stato
          pagamenti
          info
          note
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteBonusGenerationProcess">
    >
  >;
}
